<style scoped>
.form-control {
  border: none;
  background: #eee;
  font-size: 1.2em;
  color: #000;
}

.account-type{
  margin-right: 1em;
  border: 2px solid #e5e5e5;
  border-radius: 12px;
  padding: 0.15em 0.8em 0.3em 0.6em;
}

.account-type.selected{
  background: #e8e8e8;
}

.account-type input{
  display: inline-block;
  margin-right: 0.2em;
}

.input-group-text{
  background-color: #e3e3e3;
}

.input-group-prepend + input{
  border-left: 1px solid #c5c5c5 !important;
}

.input-group-prepend + input::placeholder{
  color: #aaa
}

.input-group-prepend + input::-moz-placeholder{
  color: #aaa
}

.input-group-prepend + input::-webkit-input-placeholder{
  color: #aaa
}

input::placeholder{
  color: #aaa !important;
}

input::-moz-placeholder{
  color: #aaa !important;
}

input::-webkit-input-placeholder{
  color: #aaa !important;
}
</style>

<style>
  .modal-dialog {
    width: 520px;
    max-width: 520px;
  }
</style>

<template>
  <form id="recordBalance" @submit="recordBalance">
    <b-modal title="Record Bank Balance" :visible="true" @ok="close" @cancel="close" @hide="close">
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="form-group">
            <label>Account Type</label>
            <div>
              <label v-for="(type, index) in ['Bank', 'Collection']"
                :key="index"
                class="account-type" :class="{'selected': accountType === type}"
                :from="'accountType' + index">
                <input
                  :id="'accountType' + index"
                  name="accountType"
                  type="radio"
                  :value="type"
                  v-model="accountType"
                />
                {{type}}
              </label>
            </div>
            <span
              v-if="formHasError && !accountType"
              class="hel-block text-danger">
              Choose at least one option
            </span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Vendor</label>
            <div>
              <label v-for="(type, index) in vendorChoices"
                :key="index"
                class="account-type" :class="{'selected': vendor === type}"
                :from="'vendor' + index">
                <input
                  :id="'vendor' + index"
                  name="vendor"
                  type="radio"
                  :value="type"
                  v-model="vendor"
                />
                {{type}}
              </label>
            </div>
            <span
              v-if="formHasError && !vendor"
              class="hel-block text-danger">
              Please choose a vendor
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-4">
            <label for="date">Date</label>
            <input
              autocomplete="off"
              id="date"
              class="form-control"
              type="text" required
              :value="balanceDate"
              onkeydown="if(event.keyCode !== 9) return false"
              @focus="$refs.date.show()"
              @keyup.space="$refs.date.show()"
              @click="$refs.date.show()"
            />
            <input type="hidden" v-model="date" />

            <MonthPickerInput ref="date"
              v-model="date"
              :max="today"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-4">
            <label for="amount">Amount</label>
            <input
              id="amount"
              type="text"
              class="form-control"
              required
              :value="formattedAmount"
              @keyup="setAmount($event)"
            />
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="remarks">Remarks</label>
        <textarea
          id="remarks"
          class="form-control"
          type="text"
          rows="3"
          v-model="remarks"
        />
      </div>

      <template slot="modal-footer">
        <div class="row justify-content-end">
          <div class="px-3 mt-2">
            <button
              :class="{disabled: creatingBankBalance}"
              class="btn btn-primary px-4"
            >{{ !creatingBankBalance ? 'SUBMIT' : 'Please Wait...' }}</button>
          </div>
        </div>
      </template>
    </b-modal>
  </form>
</template>

<script>
import { mapState } from "vuex";
import MonthPickerInput from '../../components/MonthPickerInput';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
let today = new Date();
today.setDate(5);

export default {
  name: "RecordBankBalance",
  data() {
    return {
      accountType: 'Bank',
      vendor: null,
      amount: 0,
      date: new Date(),
      today,
      remarks: '',
      formHasError: false
    };
  },
  computed: {
    ...mapState(["creatingBankBalance"]),
    vendorChoices: function(){
      var accountVendorMap = {
        'Bank': ['DTB', 'CRDB'],
        'Collection': ['Tigopesa', 'M-pesa']
      };

      return accountVendorMap[this.accountType];
    },
    formattedAmount: function() {
      if (this.amount && this.amount.length)
        return parseInt(this.amount.replace(/,/g, "")).toLocaleString();
      return "";
    },
    balanceDate: function(){
      if(!this.date || !new Date(this.date))
        return "";

      var date = new Date(this.date);
      return `${months[date.getMonth()]}, ${date.getFullYear()}`
    },
  },
  methods: {
    close() {
      this.$router.replace("/bankBalances/");
    },
    setAmount(e) {
      const value = e.target.value;
      const isLetter = e.keyCode >= 65 && e.keyCode <= 90;

      if (isLetter) e.target.value = value.substr(0, value.length - 1);
      else this.amount = value;
    },
    recordBalance(e) {
      e.preventDefault();

      if (!this.accountType || !this.vendor) {
        this.formHasError = true;
        return;
      }

      const data = {
        accountType: this.accountType.toLowerCase(),
        vendor: this.vendor.toLowerCase().replace("-", ""),
        amount: parseInt(this.amount.replace(/,/g, "")),
        date: this.date,
        remarks: this.remarks,
      };

      this.$store.dispatch("recordBankBalance", data);
    }
  },
  components: {
    MonthPickerInput
  }
};
</script>
